import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/recruit/casual/CasualClient.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui-utilities.scss");
